<template>
    <div>
        <vs-row>
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{ $t("message.creditCard") }}</span>
                <div class="user-info mt-4 mb-5">
                    <h5>{{ $t("lang.hi") }} {{ currentUser.name }}</h5>
                    <h5>{{ $t("lang.welcome") }}：{{ customer.accountId }}</h5>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="text-right">
                    <span class="time">{{$t('message.lastUpdate')}}: {{currentUser.updatedAt | timeFormat}}</span>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="card-list">
            <vs-col vs-w="6">
                <img  :src="require('@/assets/images/credit-card.png')" width="200px" alt="">
            </vs-col>
            <vs-col vs-w="6">
                <div class="parent-container">
                    <div class="balance-history">
                        <ul>
                            <li><h5>{{ $t("lang.total_balance") }} : {{ customer.totalBalance ? customer.totalBalance.toLocaleString() : 0 }}</h5></li>
                            <li><h5>{{ $t("lang.total_credit") }} : {{ customer.totalCredit ? customer.totalCredit.toLocaleString() : 0 }}</h5></li>
                        </ul>
                    </div>
                    <div class="currency">
                        <h5>{{ $t("lang.currency") }}:{{ $t('lang.usd') }}</h5>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <div class="update-table table-container">
            <table style="width: 100%;">
                <tr>
                    <th>{{ $t("lang.card_number") }}</th>
                    <th>{{ $t("lang.expiry_date") }}</th>  
                    <th>{{ $t("lang.card_holder_name") }}</th>
                    <th>{{ $t("lang.total_credit_limit") }}</th>
                    <th>{{ $t("lang.used_credit") }}</th>
                    <th>{{ $t("lang.remaining_limit") }}</th>
                </tr>
                <tr>
                    <td>{{ creditCard.cardNumber ? formatCard(creditCard.cardNumber) : "" }}</td>
                    <td>{{ creditCard.expiryDate }}</td>
                    <td>{{ creditCard.cardHolderName }}</td>
                    <td>{{ creditCard.totalCardLimit ? parseFloat(creditCard.totalCardLimit).toFixed(2).toLocaleString() : "" }}</td>
                    <td>{{ creditCard.usedCredit ? parseFloat(creditCard.usedCredit).toFixed(2).toLocaleString() : "" }}</td>
                    <td>{{ creditCard.remainingLimit ? parseFloat(creditCard.remainingLimit).toFixed(2).toLocaleString() : "" }}</td>
                </tr>
            </table>
        </div>
        <div class="latest-transaction">
            <h5 class="mt-5">{{ $t("lang.latest_transactions") }}：</h5>
            <div class="update-table table-container">
                <table style="width: 100%;">
                    <tr>
                        <th>{{ $t("lang.spending_date") }}</th>
                        <th>{{ $t("lang.deduct_date") }}</th>  
                        <th>{{ $t("lang.spending_detail") }}</th>
                        <th>{{ $t("lang.spending_location") }}</th>
                        <th>{{ $t("lang.international_ex_fee") }}</th>
                        <th>{{ $t("lang.usd_deduct_amount") }}</th>
                        <th>{{ $t("lang.fx_charge_date") }}</th>
                        <th>{{ $t("lang.currency_type") }}</th>
                    </tr>
                    <tr v-for="(transaction, index) in transactions" :key="index">
                        <td>{{ moment(transaction.spendingDate).format("DD/MM/YYYY") }}</td>
                        <td>{{ moment(transaction.deductDate).format("DD/MM/YYYY") }}</td>
                        <td>{{ transaction.spendingDetail }}</td>
                        <td>{{ transaction.spendingLocation }}</td>
                        <td>{{ formatCurrency(transaction.internationalExchangeFee) }}</td>
                        <td>{{ formatCurrency(transaction.usdDeductAmount) }}</td>
                        <td>{{ moment(transaction.fxChargeDate).format("DD/MM/YYYY") }}</td>
                        <td>{{ transaction.currencyType }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import $cookies from "vue-cookies";
    import moment from 'moment';


    export default {
        beforeRouteEnter(to, from, next){
            if($cookies.get('role') == 'user'){
                next()
            }else if($cookies.get('role') == 'agent'){
                next('/customer')
            }else if($cookies.get('role') == 'admin'|| $cookies.get('role') == 'manager'){
                next('/account_staff')
            }
        },
        data() {
            return {
                creditCard: {
                    cardHolderName: "",
                    cardNumber: "",
                    expiryDate: "",
                    remainingLimit: "",
                    totalCardLimit: "",
                    usedCredit: ""
                },
                transactions: [],
                customer: {}
            }
        },
        
        computed:{
            ...mapGetters(["currentUser"])
        },
        
        created() {
            let url = process.env.VUE_APP_API_BASEURL + '/api/me?access_token=' + this.$cookies.get('token');
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
                this.customer = data.responseDetail.customer;
                if(data.responseDetail.customer.creditCard){
                    this.creditCard = data.responseDetail.customer.creditCard;
                }
                if(data.responseDetail.transactions){
                    this.transactions = data.responseDetail.transactions;
                }
            })
        },
        methods: {
            moment, 
            formatCard(card){
                let timeString = card.slice(0, 4) + "********" + card.slice(12);
                return timeString;
            },
            formatCurrency(value) {
                return value ? parseFloat(value).toFixed(2).toLocaleString() : "N/A";
            }

        },
    }
</script>

<style scoped>
.parent-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.parent-container .currency{
    margin-top: 20px;
    align-self: flex-end;
}

.balance-history ul>li{
    margin-bottom: 10px;
}

/* table style */
.update-table table tr th{
    text-align: center;
}

.update-table table{
    border-collapse: separate;
    border-spacing: 1px 10px; 
}
.update-table table tr td{
    text-align: center;
    background-color: #C8DFCE;
    padding: 5px 0px 5px 0px;
    color: #000;
}
.update-table table tr td:first-child{
    border-radius: 10px 0px 0px 10px;
}

.update-table table tr td:last-child{
    border-radius: 0px 10px 10px 0px;
    border-right: none;
}

@media (max-width: 768px) {
    .card-list{
        flex-direction: column;
        /* align-items: center; */
    }
    .table-container {
        overflow: auto;
    }
}

</style>
